var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewTutorialBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    clipPath: "url(#clip0_1268_933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.22266 8.26406H10.5273C10.9385 8.26406 11.2719 7.93071 11.2719 7.51953C11.2719 7.10835 10.9385 6.775 10.5273 6.775H3.22266C2.81147 6.775 2.47812 7.10835 2.47812 7.51953C2.47812 7.93071 2.81147 8.26406 3.22266 8.26406Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.80859 9.35312H3.22266C2.81147 9.35312 2.47812 9.68647 2.47812 10.0977C2.47812 10.5088 2.81147 10.8422 3.22266 10.8422H8.80859C9.21977 10.8422 9.55312 10.5088 9.55312 10.0977C9.55312 9.68647 9.21977 9.35312 8.80859 9.35312Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.80859 11.9312H3.22266C2.81147 11.9312 2.47812 12.2646 2.47812 12.6758C2.47812 13.087 2.81147 13.4203 3.22266 13.4203H8.80859C9.21977 13.4203 9.55312 13.087 9.55312 12.6758C9.55312 12.2646 9.21977 11.9312 8.80859 11.9312Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.80859 14.5094H3.22266C2.81147 14.5094 2.47812 14.8427 2.47812 15.2539C2.47812 15.6651 2.81147 15.9984 3.22266 15.9984H8.80859C9.21977 15.9984 9.55312 15.6651 9.55312 15.2539C9.55312 14.8427 9.21977 14.5094 8.80859 14.5094Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.7196 14.9379L21.8819 18.1002C22.1727 18.3909 22.1727 18.8623 21.8819 19.153C21.8819 19.153 21.8819 19.1531 21.8818 19.1531M18.7196 14.9379L20.8997 19.0823C21.0255 19.2082 21.1905 19.2711 21.3554 19.2711C21.5203 19.2711 21.6853 19.2082 21.8111 19.0823L21.8818 19.1531M18.7196 14.9379C20.0158 13.1368 19.8549 10.6041 18.2359 8.98513C17.8316 8.58079 17.365 8.26087 16.8578 8.03398V4.94141C16.8578 4.74396 16.7794 4.5546 16.6397 4.41497C16.6397 4.41497 16.6397 4.41496 16.6397 4.41496L12.343 0.118107C12.2034 -0.0215275 12.014 -0.1 11.8166 -0.1L2.36328 -0.1C1.00494 -0.1 -0.1 1.00494 -0.1 2.36328L-0.1 19.6367C-0.1 20.9951 1.00494 22.1 2.36328 22.1H14.3945C15.7529 22.1 16.8578 20.9951 16.8578 19.6367V16.4582C17.1416 16.3312 17.4127 16.1751 17.6672 15.9913M18.7196 14.9379L17.6672 15.9913M21.8818 19.1531C21.7365 19.2985 21.5457 19.3711 21.3554 19.3711C21.1651 19.3711 20.9743 19.2984 20.829 19.153L17.6672 15.9913M21.8818 19.1531L17.6672 15.9913M12.7669 14.4541L12.6962 14.5249L12.7669 14.4541C12.177 13.8642 11.8523 13.0804 11.8523 12.2461C11.8523 11.4118 12.177 10.628 12.7669 10.038L12.6962 9.96733L12.7669 10.038C13.3568 9.4481 14.1407 9.12344 14.9749 9.12344C15.2822 9.12344 15.5824 9.16777 15.8686 9.2528C15.8838 9.25811 15.8993 9.26293 15.915 9.26726C16.3882 9.41597 16.822 9.67696 17.183 10.038C18.4004 11.2555 18.4004 13.2367 17.183 14.4541C16.822 14.8151 16.3883 15.0761 15.9153 15.2248C15.8993 15.2292 15.8837 15.2341 15.8684 15.2394C15.5822 15.3244 15.2821 15.3687 14.9749 15.3687C14.1407 15.3687 13.3568 15.0441 12.7669 14.4541ZM12.5609 2.44202L14.3158 4.19688H12.5609V2.44202ZM15.3687 19.6367C15.3687 20.1738 14.9316 20.6109 14.3945 20.6109H2.36328C1.82619 20.6109 1.38906 20.1738 1.38906 19.6367L1.38906 2.36328C1.38906 1.82619 1.82619 1.38906 2.36328 1.38906L11.0719 1.38906V4.94141C11.0719 5.35259 11.4052 5.68594 11.8164 5.68594H15.3687V7.65113C15.2386 7.6401 15.1072 7.63438 14.9749 7.63438C13.7433 7.63438 12.5848 8.11422 11.714 8.98513C10.8431 9.85604 10.3632 11.0145 10.3632 12.2461C10.3632 13.4778 10.8431 14.6362 11.714 15.5071C12.5848 16.378 13.7433 16.8578 14.9749 16.8578C15.1072 16.8578 15.2386 16.8521 15.3687 16.8411V19.6367Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewTutorialBox);
export default __webpack_public_path__ + "static/media/preview-tutorial-box.698248f74b24756e13db31879dcfbfa6.svg";
export { ForwardRef as ReactComponent };